import React from "react";
import { useHistory } from "react-router-dom";
import ForgotPassword from "../../../components/VendorComponents/VendorLogin/LoginScreen/ForgotPassword";
import { getServerKey } from "../../../services/encription/encriptionServices";
import {
  decryption,
  encryption,
} from "../../../services/encription/encryption";
import { vendorForgotPassword } from "../../../services/login/loginApiService";
import { keyClockclient } from "../../Constants/commenFeatures";
import { RoutesUrl } from "../../Routes/constents";

export interface VendorForgetPasswordState {
  disableForm: boolean;
  errorMsg?: string;
  popupMessage?: string;
}

const VendorForgetPassword: React.FC = () => {
  // login starts with LOGIN screen
  const [loginCtrl, setLoginCtrl] = React.useState<VendorForgetPasswordState>({
    disableForm: false,
    errorMsg: undefined,
  });
  const [email, setEmail] = React.useState<string>("");

  const history = useHistory();

  const submitForgotPassword = async () => {
    localStorage.setItem("email", email);
    await getServerKey(getServerTokenRes);
  };

  const getServerTokenRes = async (res: any, newResp: any) => {
    var SPK = newResp.headers.get("SPK");
    if (res && res.error) {
      setLoginCtrl({
        disableForm: true,
        errorMsg: "Something went wrong, Please try again later",
      });
    } else {
      let jsonData = JSON.stringify({
        email: email,
        client: keyClockclient,
      });
      // Here we are encrypt the data
      let encrypedForm = await encryption(SPK, jsonData);

      vendorForgotPassword(
        submitForgotPasswordRes,
        encrypedForm.reqObj,
        encrypedForm.header
      );
    }
  };
  const submitForgotPasswordRes = async (res: any, newResp: any) => {
    if (res && res.error) {
      setLoginCtrl({
        disableForm: true,
        errorMsg: res.error.errorMessage,
      });
    } else if (res && res.response) {
      let CEPRK = newResp.headers.get("CEPRK");

      let decryptedData = await decryption(CEPRK, res.response);
      console.log("decryptedData", decryptedData);
      if (decryptedData && decryptedData.status) {
        history.push(RoutesUrl.VendorSetPassword);
      }
    } else {
      setLoginCtrl({
        disableForm: true,
        errorMsg: "Request failed",
      });
    }
  };

  const onClose = () => {
    history.push(RoutesUrl.Home);
  };

  const removeError = () => {
    setLoginCtrl({
      disableForm: false,
      errorMsg: undefined,
    });
  };

  const getScreen = () => {
    return (
      <div className="vendor_login">
        <ForgotPassword
          disableForm={loginCtrl.disableForm}
          onSubmit={submitForgotPassword}
          errorMsg={loginCtrl.errorMsg}
          onRemoveError={removeError}
          onClose={onClose}
          email={email}
          setEmail={setEmail}
        />
      </div>
    );
  };

  return <div>{getScreen()}</div>;
};

export default VendorForgetPassword;
